import request from "../../../infra/request";

const INCOMING_REFERRAL_URL =
  process.env.REACT_APP_DATA_SOURCE === "pms-api" ? "/pms/admin/incoming-referrals" : "/admin/incoming-referrals";

export const downloadReferralFile = async (id, source = "ocr_clients") => {
  if (!id) {
    return { error: new Error("The file id can not be empty") };
  }
  try {
    const response = await request.get(`/admin/incoming-referrals/file/${id}`, { headers: { source } });
    return { data: response.data };
  } catch (error) {
    return {
      error: {
        message: error.message,
        code: error.response?.code || error.response?.statusText,
        status: error.response?.status,
      },
    };
  }
};

export const saveReferralData = async (referral, source) => {
  try {
    const response = await request.post(INCOMING_REFERRAL_URL, { referral }, { headers: { source } });
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const saveReferralDataR = async (referral, source = "ocr_clients") => {
  try {
    const response = await request.post(`${INCOMING_REFERRAL_URL}/r`, { referral }, { headers: { source } });
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const createWorkflowByIncomingReferral = async (incomingReferralId) => {
  try {
    const response = await request.post(`${INCOMING_REFERRAL_URL}/workflow`, { incomingReferralId });
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const createWorkflowByIncomingReferralR = async (incomingReferralRId) => {
  try {
    const response = await request.post(`${INCOMING_REFERRAL_URL}/workflow/r`, { incomingReferralRId });
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};
